import { Inject } from "inversify-props";
import type { RegraDeInadimplenciaServiceAdapter } from "./adapter/RegraDeInadimplenciaServiceAdapter";
import { AxiosRequestConfig } from "axios";
import { Page, RegraDeInadimplencia } from "@/models";

export class FindRegraDeInadimplenciaUseCase {
	@Inject('RegraDeInadimplenciaServiceAdapter')
		private regraDeInadimplenciaServiceAdapter!: RegraDeInadimplenciaServiceAdapter

	findPageRegrasDeInadimplencia = async (params?: any, config?: AxiosRequestConfig): Promise<Page<RegraDeInadimplencia>> =>
		await this.regraDeInadimplenciaServiceAdapter.findPageRegrasDeInadimplencia(params, config)
}